import { useContext } from "react";
import { ShirtAreaContext } from "../contexts";

const useShirtArea = () => {
  return useContext(ShirtAreaContext);
};

export default useShirtArea;
